<template>
  <b-overlay :show="busy">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" sm="10" lg="5">

          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Login</span>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-alert v-if="error" show variant="danger" class="mt-2">
            Invalid login - please try again.
          </b-alert>

          <b-form @submit.prevent="login" v-if="show">
            <b-input-group class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="person-fill"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="username"
                v-model="form.username"
                type="text"
                required
                placeholder="Enter username"
              ></b-form-input>
            </b-input-group>

            <b-input-group class="mb-2">
              <b-input-group-prepend is-text>
                <b-icon icon="lock"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="password"
                v-model="form.password"
                type="password"
                required
                placeholder="Enter password"
              ></b-form-input>
            </b-input-group>

            <b-button type="submit" variant="primary" class="w-100">Login</b-button>
          </b-form>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mt-2">
        <b-col cols="6" sm="5" lg="3">
            <b-link :to="{ path: '/register', query: {rurl: rurl}}">Create Free Account</b-link>
        </b-col>
        <b-col cols="6" sm="5" lg="2" class="text-right">
            <b-link to="/recover">Forgot password?</b-link>
        </b-col>
      </b-row>

    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

// URL paramas
// https://www.thepolyglotdeveloper.com/2017/11/pass-data-between-routes-vuejs-web-application/
// import router from "../router";

import service from "@/service/service";

// using props for url parameters
// https://www.youtube.com/watch?v=ESg0k2zdME4

export default {
  name: "Login",
  data() {
    return {
      debug: false,
      msg: "Viva Account Login",
      show: true,
      busy: false,
      error: false,
      studentHash: null,
      rurl: null,
      form: { username: "", password: "" }
    }
  },
  props: {
    // route set to use props mapped to url parameters
    s: {
      type: String,
      default: ""
    }
  },
  computed: {
    isLoggedIn() {
        return this.$root.hasToken()
    }
  },
  methods: {
    login(e) {
      // e.preventDefault();  // used submit.prevent
      this.error = false
      this.busy = true
      // console.log(`u: ${this.form.username}  p: ${this.form.password}`);
      service
        .login(this.form.username, this.form.password)
        .then( res => {
          if (this.debug) console.log(res);
          if (res.status) {
            this.studentHash = res.hash;
            this.$root.setToken(res.token); // logs student in
            this.$root.setStudentHash(this.studentHash)
            this.$root.setStudentName(res.title, res.firstname, res.lastname)
            this.$root.setStudentEmail(res.email)

            // smart redirect
            this.$router.push({ path: this.rurl })
          } else {
            // error bad login
            this.error = true
          }
        })
        .finally(e => {
          this.busy = false
        })
        .catch(e => {
          console.log(e)
          this.error = true
        })
    }
  },
  created() {
    // props:
    // /login/:s/:c
    // url
    // /login?s=sss&c=ccc

    // try to get from props, url param, global
    this.studentHash = this.s || this.$route.query.s || this.$root.getToken() || null
    this.rurl = this.$route.query.rurl || '/home'
    if (this.debug) console.log(`Login.created - s: ${this.studentHash}  rurl: ${this.rurl}`);
  },
  mounted() {
    // console.log(`Component: ${this.type}`)
    // console.log(`studentId: ${this.$root.studentId}`);
    // console.log(`getStudentId: ${this.$root.getStudentId()}`);
    if (this.debug) console.log(`Login.mounted - s: ${this.studentHash}  rurl: ${this.rurl}`);

    this.error = false
    this.busy = true

    if (this.studentHash) {
      service
        .getStudent(this.studentHash)
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
              this.$root.setStudentHash(res.student.hash)
              this.$root.setToken(res.student.hash)
              this.$root.setStudentName(res.student.title, res.student.firstname, res.student.lastname)
              this.$root.setStudentEmail(res.student.email)

              this.$router.push({ path: this.rurl })
            }
          }).bind(this)
        )
        .finally(e => {
          this.busy = false
          // console.log(`finally...`)
        })
        .catch(e => console.log(e))
    }
    else {
      this.busy = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue